import { APIResponseType } from 'app/apiService/types';
import apiService from 'app/apiService';

class DealerService {
  static ENDPOINT = 'api/v2/dealers';

  /**
   * Get all dealers from API
   * @returns Promise with dealers list
   */
  static async getAllDealers(): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(this.ENDPOINT);
      return response;
    } catch (error) {
      console.error('Error fetching dealers:', error);
      throw error;
    }
  }
}

export default DealerService;

